import type { Screen } from '@ghostscreen/contracts';
import { getOperatorDisplayStatus, type OperatorDisplayStatus } from '../../lib/dashboard/operatorDisplayStatus';

export type HomeDisplayRow = {
  id: string;
  name: string;
  status: OperatorDisplayStatus;
  playlistName: string | null;
};

/**
 * Active-display rows for mobile Home — status + what's playing.
 * Prefer connected/syncing first, then offline, then not-connected.
 */
export function buildHomeDisplayRows(
  screens: Screen[],
  assignments: Map<string, string | null>,
  playlists: { id: string; name: string }[],
): HomeDisplayRow[] {
  const playlistNameById = new Map(playlists.map((playlist) => [playlist.id, playlist.name]));

  const rows = screens.map((screen) => {
    const playlistId = assignments.get(screen.id) ?? null;
    return {
      id: screen.id,
      name: screen.name,
      status: getOperatorDisplayStatus(screen),
      playlistName: playlistId ? (playlistNameById.get(playlistId) ?? null) : null,
    };
  });

  const rank: Record<OperatorDisplayStatus, number> = {
    connected: 0,
    syncing: 1,
    offline: 2,
    'not-connected': 3,
  };

  return rows.sort((a, b) => {
    const byStatus = rank[a.status] - rank[b.status];
    if (byStatus !== 0) return byStatus;
    return a.name.localeCompare(b.name);
  });
}

export function countConnectedDisplays(rows: HomeDisplayRow[]): number {
  return rows.filter((row) => row.status === 'connected' || row.status === 'syncing').length;
}
